import React, { Component } from "react";
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import backend_url from "../../../routes/API_URL";
import moment from "moment";
import swal from 'sweetalert';

const API_URL = backend_url['api_url'];

class DistrictProgressGraph extends Component {
  constructor(props) {
    super(props);
    
    // Get district_id from props
    const district_id = this.props.district_id;
    console.log('DistrictProgressGraph received district_id:', district_id);
    
    const end_date = new Date().getFullYear();
    const start_date = end_date - 3;
    
    this.state = {
      header: props.header ? props.header : 'years',
      GraphicalData: [],
      bearer_auth: window.sessionStorage.getItem('token'),
      district_id: district_id,
      district_name: '',
      start_date: props.start ? new Date(props.start).getFullYear() : start_date,
      end_date: props.end ? new Date(props.end).getFullYear() : end_date,
      start: props.start ? moment(props.start).startOf('year').format("YYYY-MM-DD") : moment().subtract(3, 'years').startOf('year').format("YYYY-MM-DD"),
      end: props.end ? moment(props.end).endOf('year').format("YYYY-MM-DD") : moment().endOf('year').format("YYYY-MM-DD"),
      level: props.level || '',
      loading: false,
      error: null,
      dataFetched: false
    };
  }
  
  componentDidMount() {
    this.fetchDistrictData();
  }
  
  componentDidUpdate(prevProps) {
    // Check if district_id changed
    if (this.props.district_id !== prevProps.district_id) {
      console.log('DistrictProgressGraph - district_id changed:', this.props.district_id);
      this.setState({ 
        district_id: this.props.district_id,
        dataFetched: false,
        error: null
      }, () => {
        this.fetchDistrictData();
      });
    }
  }
  
  fetchDistrictData() {
    const { district_id, start, end, level, bearer_auth } = this.state;
    
    // Validate district_id
    if (!district_id || district_id === 'undefined' || district_id === 'null' || district_id === '') {
      console.error('DistrictProgressGraph - Invalid district ID:', district_id);
      this.setState({ 
        GraphicalData: [],
        error: 'Invalid district ID',
        loading: false,
        dataFetched: true
      });
      return;
    }

    console.log('DistrictProgressGraph - Fetching data for district:', district_id);
    this.setState({ loading: true, error: null });

    Promise.all([
      axios.get(`${API_URL}/progress_report/district/${district_id}?start_date=${start}&end_date=${end}&level=${level}`, 
        { headers: { "Authorization": `Bearer ${bearer_auth}` } }
      ).catch(error => {
        console.error('Error fetching progress data:', error);
        return { data: [] };
      }),
      axios.get(`${API_URL}/districts/${district_id}`,
        { headers: { "Authorization": `Bearer ${bearer_auth}` } }
      ).catch(error => {
        console.error('Error fetching district details:', error);
        return { data: { data: [] } };
      })
    ]).then(([g_data, district_data]) => {
      console.log('District progress data received:', g_data.data);
      
      // Handle different response formats
      let progressData = [];
      if (Array.isArray(g_data.data)) {
        progressData = g_data.data;
      } else if (g_data.data && Array.isArray(g_data.data.data)) {
        progressData = g_data.data.data;
      }
      
      // Get district name from response
      let districtName = 'Unknown District';
      if (district_data.data && district_data.data.length >= 1) {
        districtName = district_data.data[0]['district_name'];
      } else if (district_data.data && district_data.data.district_name) {
        districtName = district_data.data.district_name;
      }
      
      this.setState({
        GraphicalData: progressData,
        district_name: districtName,
        loading: false,
        dataFetched: true
      });
    }).catch(error => {
      console.error('Error in fetchDistrictData:', error);
      this.setState({ 
        GraphicalData: [],
        error: 'Failed to load district progress data',
        loading: false,
        dataFetched: true
      });
    });
  }
  
  render() {
    const { GraphicalData, district_name, start_date, end_date, start, end, header, loading, error, dataFetched } = this.state;

    if (loading) {
      return (
        <div className="text-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p>Loading district progress data...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="text-center p-5">
          <h5 className="text-danger">{error}</h5>
          <p>District ID: {this.state.district_id || 'Not provided'}</p>
          <p>Unable to load progress data for this district.</p>
        </div>
      );
    }

    if (dataFetched && (!GraphicalData || GraphicalData.length === 0)) {
      return (
        <div className="text-center p-5">
          <h5>No Progress Data Available</h5>
          <p>District: {district_name}</p>
          <p>There is no inspection data available for this district in the selected period.</p>
        </div>
      );
    }

    if (!GraphicalData || GraphicalData.length === 0) {
      return (
        <div className="text-center p-5">
          <h5>Loading data...</h5>
        </div>
      );
    }

    // Process data for chart
    const years = [];
    for (let i = 0; i < GraphicalData.length; i++) {
      let formated_date = GraphicalData[i]['DATE'];
      if (formated_date && !years.includes(formated_date)) {
        years.push(formated_date);
      }
    }
    years.sort();
    
    let level_one_data = [];
    let level_two_data = [];
    let level_three_data = [];
    let level_four_data = [];
    
    for (let idx = 0; idx < years.length; idx++) {
      level_one_data.push(0);
      level_two_data.push(0);
      level_three_data.push(0);
      level_four_data.push(0);
    }
    
    const entryFrequency = (obj) => {
      const level_freq = {};
      obj.forEach(idx => {
        if (level_freq[idx]) {
          level_freq[idx]++;
        } else {
          level_freq[idx] = 1;
        }
      });
      return level_freq;
    }
    
    for (let m = 0; m < years.length; m++) {
      const uncategorised_levels = [];
      for (let n = 0; n < GraphicalData.length; n++) {
        let formated_date = GraphicalData[n]['DATE'];
        let level_achieved = GraphicalData[n]['level_achieved'];
        
        if (years[m] === formated_date && level_achieved) {
          uncategorised_levels.push(level_achieved.toString());
        }
      }
      
      if (uncategorised_levels.length > 0) {
        const categorised_levels = entryFrequency(uncategorised_levels);
        let total_level_data = 0;
        
        for (const v in categorised_levels) {
          total_level_data += categorised_levels[v];
        }
        
        for (const idx in categorised_levels) {
          const percentage = parseFloat((categorised_levels[idx] / total_level_data) * 100).toFixed(2);
          
          if (idx === '1') {
            level_one_data[m] = percentage;
          } else if (idx === '2') {
            level_two_data[m] = percentage;
          } else if (idx === '3') {
            level_three_data[m] = percentage;
          } else if (idx === '4') {
            level_four_data[m] = percentage;
          }
        }
      }
    }

    const series = [
      { name: 'Level 1 - Does not meet minimum standards', data: level_one_data },
      { name: 'Level 2 - Meets Minimum Standards', data: level_two_data },
      { name: 'Level 3 - Exceeds Minimum Standards', data: level_three_data },
      { name: 'Level 4 - Effective Practice', data: level_four_data }
    ];

    const title = header === 'dates' 
      ? `${district_name} District Progress Report from ${start} to ${end}`
      : `${district_name} District Progress Report from ${start_date} to ${end_date} (${end_date - start_date + 1} Year(s))`;

    const options = {
      chart: {
        type: 'bar',
        height: 500,
        stacked: true,
        stackType: '100%'
      },
      colors: ['#ff0000', '#0018ff', '#fffc00', '#1bb60b'],
      plotOptions: {
        bar: { horizontal: false }
      },
      title: {
        text: title,
        align: 'center',
        style: { fontSize: '14px', fontWeight: 'bold' }
      },
      xaxis: {
        categories: years,
        title: { text: 'INSPECTION YEAR(S)' }
      },
      yaxis: {
        max: 100,
        title: { text: 'PERCENTAGE OF SCHOOLS' },
        labels: { formatter: (value) => value ? value + '%' : '0%' }
      },
      tooltip: {
        y: { formatter: (value) => value ? value + '%' : '0%' }
      },
      legend: { position: 'bottom' }
    };

    return (
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <ReactApexChart options={options} series={series} type="bar" height={500} />
          </div>
        </div>
      </div>
    );
  }
}

export default DistrictProgressGraph;